// extracted by mini-css-extract-plugin
export default {"powertrains":"Powertrains__powertrains--DNQZ8"};